import { Directive, HostListener, Input } from '@angular/core';

const BLOCK_LENGTH = 4;
const PUT_SEPARATOR = 3;
const MAX_LENGTH = 9;
export const TAJ_FULL_LENGTH = 11;

@Directive({
  selector: '[incSinController]'
})
export class SinControllerDirective {

  @Input() incSinIsActive = true;

  seleniumTest = false;

  @HostListener('keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    this.separatorController(event);
  }

  @HostListener('ended', ['$event']) // for selenium test
  testEvent(event: Event) {
    console.log('ended event', event);
    this.seleniumTest = true;
    console.log('test', this.seleniumTest);
  }

  constructor() {
  }

  separatorController(event: any): void {
    if (this.incSinIsActive) {
      const length = event.target.value.length;

      if (event.key !== 'Backspace') {
        if (length % BLOCK_LENGTH === PUT_SEPARATOR && length <= MAX_LENGTH) {
          event.target.value += '-';
        }
        if (Number.isNaN(Number(event.key)) || length > MAX_LENGTH + 1 || event.key === ' ') {
          if (!this.seleniumTest) {
            event.preventDefault();
          }
        }
      }
    }
  }

}
